module.exports = __webpack_public_path__ + "img/trend-down.cc79cad8.svg";